import { useEffect, useState } from "react";
import { Circle, MapContainer, Marker, Polyline, TileLayer, Tooltip } from "react-leaflet";
import L from 'leaflet';
import markerIconLayer from 'leaflet/dist/images/layers.png';

import "./Geographie.css";
import 'leaflet/dist/leaflet.css';
import DatenLaden from "../Tabellen/DatenLaden";
import { Categories } from "../MainMenu/MenüSicht";


export function Bahnhofsgeographie({ instance, hsInstance }) {
    const [listOfLinien, setListOfLinien] = useState([]);
    const [linienChecks, setLinienChecks] = useState({});
    const [allLinien, setAllLinien] = useState(false);
    const [lade, setLade] = useState(true);
    const [completeData, setCompleteData] = useState([]);
    const [chosenLinien, setChosenLinien] = useState([]);
    const [radius, setRadius] = useState(1200);

    const [listOfPB, setListOfPB] = useState([]);
    const [listOfPBVerlauf, setListOfPBVerlauf] = useState([]);
    const [allPB, setAllPB] = useState(false);
    const [radiusPB, SetRadiusPB] = useState(600);
    const [pbChecks, setPbChecks] = useState({});
    const [chosenPBHin, setChosenPBHin] = useState([]);
    const [chosenPBRueck, setChosenPBRueck] = useState([]);
    const [activeHin, setActiveHin] = useState(true);
    const [activeRueck, setActiveRueck] = useState(true);

    const [permanentLabels, setPermanentLabels] = useState(false);
    const [path, setPath] = useState({
        spnv: false,
        plusbus: false
    });
    const [ausklappsies, setAusklappsies] = useState({
        spnv: false,
        plusbus: false
    });
    
    useEffect(() => {
        setLade(true);
        instance.getListOfLinienAktuelleBahnhoefeLinienGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                console.log('load listOfLinien', data);
                setListOfLinien(data);
            }
            });

        instance.getAktuelleBahnhoefeAktuelleBahnhoefeGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                console.log('load bhfData', data);
                setCompleteData(data);
                setLade(false);
            }
        })

        hsInstance.getHsLinienHaltestellenLinienGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                console.log('load linien', data);
                setListOfPB(data);
            }
            });
        
        hsInstance.getHsVerlaufHaltestellenVerlaufGet((error, data, response) => {
            if (error) {
                console.error(error);
            } else {
                console.log('load verlauf', data);
                setListOfPBVerlauf(data);
                setLade(false);
            }
        });
    }, [hsInstance, instance]);

    useEffect(() => {
        listOfLinien.map(linie => setLinienChecks(pre => ({...pre, [linie.id]: false})));
    }, [listOfLinien]);

    useEffect(() => {
        listOfPB.map(linie => setPbChecks(pre => ({...pre, [linie.id]: false})));
    }, [listOfPB]);

    const selectLinie = event => {
        setLinienChecks(pre => ({...pre, [event.target.id]: event.target.checked}));
        if (!event.target.checked && allLinien) {
            setAllLinien(false);
        }
        if (event.target.checked && Object.keys(linienChecks).filter(linie => linie !== event.target.id).filter(l => !linienChecks[l]).length === 0) {
            setAllLinien(true);
        }
    }

    const selectPb = event => {
        setPbChecks(pre => ({...pre, [event.target.id]: event.target.checked}));
        if (!event.target.checked && allPB) {
            setAllPB(false);
        }
        if (event.target.checked && Object.keys(pbChecks).filter(linie => linie !== event.target.id).filter(l => !pbChecks[l]).length === 0) {
            setAllPB(true);
        }
    }

    const selectAll = event => {
        if (event.target.checked) {
            setAllLinien(true);
            Object.keys(linienChecks).map(linie => setLinienChecks(pre => ({...pre, [linie]: true})))

        } else {
            setAllLinien(false);
            Object.keys(linienChecks).map(linie => setLinienChecks(pre => ({...pre, [linie]: false})))
        }
    }

    const selectAllPb = event => {
        if (event.target.checked) {
            setAllPB(true);
            Object.keys(pbChecks).map(linie => setPbChecks(pre => ({...pre, [linie]: true})))

        } else {
            setAllPB(false);
            Object.keys(pbChecks).map(linie => setPbChecks(pre => ({...pre, [linie]: false})))
        }
    }

    useEffect(() => {
        const ids = Object.keys(linienChecks).filter(linie => linienChecks[linie]);
        var strecken = [];
        ids.forEach(id => {
            strecken.push(...completeData.filter(data => data.id_linie === parseInt(id)))
        })
        console.log('streckenauswahl', strecken)
        setChosenLinien(strecken);
    }, [linienChecks, completeData])

    useEffect(() => {
        const linien = listOfPB.filter(linie => Object.keys(pbChecks).filter(linie => pbChecks[linie]).includes(linie.id.toString()));
        setChosenPBHin(listOfPBVerlauf.filter(data => linien.map(linie => linie.strecke_hin).includes(data.id_strecke)));
        setChosenPBRueck(listOfPBVerlauf.filter(data => linien.map(linie => linie.strecke_rueck).includes(data.id_strecke)));
    }, [pbChecks, listOfPB, listOfPBVerlauf]);

    const ausklappen = event => {
        event.preventDefault();
        setAusklappsies(previous => ({...previous, [event.target.value]: !ausklappsies[event.target.value]}));
    }

    const makePath = event => {
        setPath(previous => ({...previous, [event.target.id]: event.target.checked}));
    }

    return (
        <>
        {lade ? <DatenLaden /> :
        <Categories>
        <h3 style={{textAlign: "center", marginBottom: "1em"}}>Lage und Einzugsbereiche der Zugangsstellen</h3>
        <div className="geographie">
            <div className="list-of-linien">
                <h4 style={{marginBottom: "0.25em"}}>SPNV - Linien</h4>
                <p style={{fontSize: "small", textAlign: "center", marginTop: "0"}}>(nur für 2021 gültige Linien)</p>
                <label><input type="checkbox" checked={allLinien} onChange={selectAll}/>Alle Linien</label>
                <label>Umkreisradius (in meter): <input type="number" step="100" value={radius} onChange={e => setRadius(e.target.value)} /></label>
                <label><input type="checkbox" value={path.spnv} onChange={makePath} id="spnv"/> Pfade</label>
                <button className="ausklappsie-bttn" value="spnv" onClick={ausklappen}>{ausklappsies.spnv ? <span>&#8659;</span> : <span>&#8658;</span>}Linienauswahl</button>
                {ausklappsies.spnv && <ul type="none" className="linien-liste">
                    {listOfLinien.map(linie => 
                        <li key={linie.id}><input id={linie.id} type="checkbox" checked={linienChecks[linie.id] || false} onChange={selectLinie}/>{linie.linie}</li>
                    )}
                </ul>}

                <h4 style={{marginBottom: "0.25em"}}>PlusBus - Linien</h4>
                <p style={{fontSize: "small", textAlign: "center", marginTop: "0"}}>(nur Auswahl aus 2019)</p>

                <label><input type="checkbox" checked={allPB} onChange={selectAllPb}/>Alle Linien</label>
                <label>Umkreisradius (in meter): <input type="number" step="100" value={radiusPB} onChange={e => SetRadiusPB(e.target.value)} /></label>
                <label><input type="checkbox" value={path.plusbus} onChange={makePath} id="plusbus"/> Pfade</label>
                <label><input type="checkbox" checked={permanentLabels} onChange={e => setPermanentLabels(e.target.checked)}/> Distanz</label>
                <label><input type="checkbox" checked={activeHin} onChange={e => setActiveHin(e.target.checked)} id="hin"/> Hinrichtung</label>
                <label><input type="checkbox" checked={activeRueck} onChange={e => setActiveRueck(e.target.checked)} id="rück"/> Rückrichtung</label>
                <button className="ausklappsie-bttn" value="plusbus" onClick={ausklappen}>{ausklappsies.plusbus ? <span>&#8659;</span> : <span>&#8658;</span>}Linienauswahl</button>
                {ausklappsies.plusbus && <ul type="none" className="linien-liste">
                    {listOfPB.map(linie => 
                        <li key={linie.id}><input id={linie.id} type="checkbox" checked={pbChecks[linie.id] || false} onChange={selectPb}/>{linie.linie}</li>
                    )}
                </ul>}
            </div>

            <div className="karte">
                <Karte chosenLinien={chosenLinien} radius={radius} radiusPB={radiusPB} PBHin={chosenPBHin} PBRueck={chosenPBRueck} path={path} activeHin={activeHin} activeRueck={activeRueck} permanentLabels={permanentLabels}/>
                <div className="legende">
                    <h4>Legende</h4>
                    <div className="legende-eintrag">
                        <div className="line spnv"></div>
                        <label>SPNV-Linien</label>
                    </div>
                    <div className="legende-eintrag">
                        <div className="line pb-hin"></div>
                        <label>PlusBus-Linien Hinrichtung</label>
                    </div>
                    <div className="legende-eintrag">
                        <div className="line pb-rueck"></div>
                        <label>PlusBus-Linien Rückrichtung</label>
                    </div>
                </div>
            </div>
        </div>
        </Categories>}
        </>
    )
}

function Karte ({ chosenLinien, radius, radiusPB, PBHin, PBRueck, path, activeHin, activeRueck, permanentLabels }) {
    return (
        <div className="map-linien-bhf">
            <MapContainer center={[50.929472, 13.458333]} zoom={8} scrollWheelZoom={true} style={{width: "100%", height: "100%"}} >
                <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                <CreatePbPaths radiusPB={radiusPB} PBHin={PBHin} PBRueck={PBRueck} activeHin={activeHin} activeRueck={activeRueck}/>
                <CreatePaths chosenLinien={chosenLinien} radius={radius}/>
                {path.spnv && <DrawPath chosenLinien={chosenLinien} color={'rgba(139, 34, 82)'}/>}
                {path.plusbus && activeRueck && <DrawPbPaths chosenPB={PBRueck} color={'rgba(0, 134, 139)'}/>}
                {path.plusbus && activeHin && <DrawPbPaths chosenPB={PBHin} color={'rgba(205, 51, 51)'}/>}
                {path.plusbus && activeRueck && !permanentLabels && <AddDistanceLabels chosenPB={PBRueck} permanent={false}/>}
                {path.plusbus && activeRueck && permanentLabels && <AddDistanceLabels chosenPB={PBRueck} permanent={true}/>}
                {path.plusbus && activeHin && !permanentLabels && <AddDistanceLabels chosenPB={PBHin} permanent={false}/>}
                {path.plusbus && activeHin && permanentLabels && <AddDistanceLabels chosenPB={PBHin} permanent={true}/>}
            </MapContainer>
        </div>
    )
}

function CreatePbPaths({ radiusPB, PBHin, PBRueck, activeHin, activeRueck}) {
    return (
        <div>
            {activeRueck && PBRueck.map(hs => <CreateCircle coords={L.latLng(hs.ykoord, hs.xkoord)} key={`${hs.id_hs}-${hs.id_strecke}`} radius={radiusPB} bhf={hs.hs} fillColor='rgba(64, 224, 208, 0.05)' color="rgba(64, 224, 208)"/>)}
            {activeHin && PBHin.map(hs => <CreateCircle coords={L.latLng(hs.ykoord, hs.xkoord)} key={`${hs.id_hs}-${hs.id_strecke}`} radius={radiusPB} bhf={hs.hs} fillColor='rgba(255, 127, 0, 0.05)' color="rgba(255, 127, 0)"/>)}
        </div>
    )
}

function DrawPbPaths ({ chosenPB, color }) {
    let all_paths = [];
    const id_strecken = new Set(chosenPB.map(strecke => strecke.id_strecke));
    id_strecken.forEach(s_id => {
        const filter = chosenPB.filter(strecke => strecke.id_strecke === s_id);
        all_paths.push(filter.sort((a, b) => a.pos > b.pos).map(hs => L.latLng(hs.ykoord, hs.xkoord)));
    });

    return (
        <div>
            <Polyline pathOptions={{color: color}} positions={all_paths} />
        </div>
    )
}

function AddDistanceLabels ({ chosenPB, permanent }) {
    const markerIconConst = L.icon({
        iconUrl: markerIconLayer,
        iconRetinaUrl: markerIconLayer,
        // iconAnchor: [5, 55],
        // popupAnchor: [10, -44],
        iconSize: [6, 10],
      });

    let all_paths = [];
    let drawing = [];
    let onePath = [];
    const id_strecken = new Set(chosenPB.map(strecke => strecke.id_strecke));
    id_strecken.forEach(s_id => {
        const filter = chosenPB.filter(strecke => strecke.id_strecke === s_id);
        all_paths.push(filter.sort((a, b) => a.pos > b.pos).map(hs => L.latLng(hs.ykoord, hs.xkoord)));
    });

    all_paths.forEach(path => {
        for (var i=0; i<path.length-1; i++) {
            const first = path[i];
            const second = path[i+1];

            const distance = Math.round(first.distanceTo(second) * 100) / 100;
            const middle = [0.5*(first.lat + second.lat), 0.5*(first.lng + second.lng)];

            onePath.push({pos: [first, second], dist: distance, middle: middle});         
        }
        drawing.push(onePath);
    })
    return (
        <div>
            {drawing.map(linie => linie.map(path => 
                <Marker position={L.latLng(path.middle)} icon={markerIconConst}>
                    <Tooltip permanent={permanent} offset={[0,0]}>{path.dist}m</Tooltip>
                </Marker>
            ))}
        </div>
    )
}

function CreatePaths ({ chosenLinien, radius }) {
    console.log("choselLinien", chosenLinien);
    return (
        <div>
            {chosenLinien.map(linie => 
                linie.data.map(bhf => 
                    ({coords: L.latLng(bhf.ykoord, bhf.xkoord), id: bhf.id_bhf, pos: bhf.position, bhf: bhf.bhf}))
                    .map(data => 
                        <CreateCircle coords={data.coords} key={`${data.id}-${data.pos}`} radius={radius} bhf={data.bhf} fillColor='rgba(205, 50, 120, 0.05)' color="rgba(205, 50, 120)"/>))}

        </div>
    )
}

function CreateCircle ({ coords, radius, bhf, fillColor, color }) {
    return (
        <Circle center={coords} pathOptions={{ width: "1", fillColor: fillColor, color: color }} radius={radius} metric={true} >
            <Tooltip>{bhf}</Tooltip>
        </Circle>
    )
}

function DrawPath ({ chosenLinien, color}) {
    return (
        <div>
            {chosenLinien.map(linie => 
                linie.data.map(bhf => 
                    L.latLng(bhf.ykoord, bhf.xkoord)))
                .map((d, index) => <Polyline pathOptions={{color: color}} positions={d} key={`${index}`} />)
            }
        </div>
    )
}